import { isCordova } from 'packages/platform-detector';

export const showMobileAppsSection = (
  programType: string,
  appStoreUrl: string
): boolean =>
  isCordova() || programType === 'disbursement' || appStoreUrl === '';

export default showMobileAppsSection;
